/**
 * ABEERS — Creator Collaboration Page
 * Vanilla JS, no dependencies. Handles:
 *   1. Smooth scrolling for in-page anchor links
 *   2. Showing/hiding the sticky mobile "Apply Now" button
 *   3. A light scroll-reveal on cards / list items
 *   4. Moving focus to the success message after submission (a11y)
 *
 * Respects prefers-reduced-motion throughout.
 */
(function () {
  'use strict';

  var root = document.getElementById('abeers-cc');
  if (!root) return;

  var prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  /* ---------------------------------------------------------------------
     0. Checkbox groups (Content Category, Interested Products, Content
        Deliverables): Shopify's native contact form doesn't support
        array-style field names (contact[Group][]), so each checkbox is
        left unnamed and, right before the form submits, we join the
        checked values into a single comma-separated hidden field
        instead (contact[Group Name]).
  --------------------------------------------------------------------- */
  var abeersForm = root.querySelector('.abeers-form');
  if (abeersForm) {
    abeersForm.addEventListener('submit', function () {
      var summaryFields = abeersForm.querySelectorAll('[data-checkbox-summary]');
      summaryFields.forEach(function (hiddenInput) {
        var groupName = hiddenInput.getAttribute('data-checkbox-summary');
        var group = abeersForm.querySelector(
          '[data-checkbox-group="' + groupName + '"]'
        );
        if (!group) return;
        var checked = group.querySelectorAll('[data-group-item]:checked');
        var values = Array.prototype.map.call(checked, function (el) {
          return el.value;
        });
        hiddenInput.value = values.join(', ');
      });
    });
  }

  /* ---------------------------------------------------------------------
     1. Smooth scroll for Apply Now / Learn More / sticky CTA
  --------------------------------------------------------------------- */
  var scrollLinks = root.querySelectorAll('.abeers-js-scroll');
  scrollLinks.forEach(function (link) {
    link.addEventListener('click', function (event) {
      var targetId = link.getAttribute('data-target');
      var targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      event.preventDefault();
      targetEl.scrollIntoView({
        behavior: prefersReducedMotion ? 'auto' : 'smooth',
        block: 'start'
      });

      // Move focus for keyboard/screen-reader users once scroll settles.
      window.setTimeout(function () {
        targetEl.setAttribute('tabindex', '-1');
        targetEl.focus({ preventScroll: true });
      }, prefersReducedMotion ? 0 : 450);
    });
  });

  /* ---------------------------------------------------------------------
     2. Sticky mobile "Apply Now" — appears once the hero has scrolled
        past, hides again once the form itself is on screen.
  --------------------------------------------------------------------- */
  var stickyCta = root.querySelector('.abeers-sticky-cta');
  var hero = root.querySelector('.abeers-hero');
  var formSection = document.getElementById('abeers-form');

  if (stickyCta && hero && 'IntersectionObserver' in window) {
    var heroObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyCta.classList.remove('abeers-is-visible');
          } else {
            stickyCta.classList.add('abeers-is-visible');
          }
        });
      },
      { threshold: 0 }
    );
    heroObserver.observe(hero);

    if (formSection) {
      var formObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              stickyCta.classList.remove('abeers-is-visible');
            }
          });
        },
        { threshold: 0.15 }
      );
      formObserver.observe(formSection);
    }
  }

  /* ---------------------------------------------------------------------
     3. Gentle scroll-reveal for cards and eligibility items
  --------------------------------------------------------------------- */
  if (!prefersReducedMotion && 'IntersectionObserver' in window) {
    var revealTargets = root.querySelectorAll(
      '.abeers-card, .abeers-who__list li'
    );

    revealTargets.forEach(function (el, index) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(12px)';
      el.style.transition =
        'opacity 420ms ease, transform 420ms ease';
      el.style.transitionDelay = Math.min(index * 60, 240) + 'ms';
    });

    var revealObserver = new IntersectionObserver(
      function (entries, observer) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    revealTargets.forEach(function (el) {
      revealObserver.observe(el);
    });
  }

  /* ---------------------------------------------------------------------
     4. Focus the success message after a successful submit so screen
        reader users immediately hear the confirmation.
  --------------------------------------------------------------------- */
  var successBox = document.getElementById('abeers-success');
  if (successBox) {
    successBox.focus();
    successBox.scrollIntoView({
      behavior: prefersReducedMotion ? 'auto' : 'smooth',
      block: 'center'
    });
  }
})();